import {
  collection,
  getCountFromServer,
  getDocs,
  limit,
  query,
  startAfter,
} from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { Box, Chip, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { reviewColumn } from "../../datatablesource";

const PAGE_SIZE = 10;
let lastVisible = null; // Move this outside the component to retain its value across renders

const Reviews = ({ bookUID }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [dataCache, setDataCache] = useState({});

  useEffect(() => {
    const fetchTotalDocuments = async () => {
      const eLibraryRef = collection(db, "eLibrary", bookUID, "reviews");
      const totalDocuments = await getCountFromServer(eLibraryRef);
      const totalDataCount = totalDocuments.data().count;
      setTotalPages(Math.ceil(totalDataCount / PAGE_SIZE));
    };

    fetchTotalDocuments();
  }, [bookUID]);

  const fetchData = async (page) => {
    setLoading(true);
    try {
      if (dataCache[page]) {
        setData(dataCache[page]);
        setLoading(false);
        return;
      }

      let userQuery;
      if (page === 0) {
        userQuery = query(
          collection(db, "eLibrary", bookUID, "reviews"),
          limit(PAGE_SIZE)
        );
        lastVisible = null; // Reset lastVisible when fetching the first page
      } else {
        userQuery = query(
          collection(db, "eLibrary", bookUID, "reviews"),
          startAfter(lastVisible),
          limit(PAGE_SIZE)
        );
      }

      const querySnapshot = await getDocs(userQuery);
      lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];

      const newData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setDataCache((prevCache) => ({ ...prevCache, [page]: newData }));
      setData(newData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(page);
  }, [page]);

  const actionColumn = [
    {
      field: "status",
      headerName: "Status",
      width: 100,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => {
        return (
          <div className="cellAction">
            <Chip
              label={params.row.status}
              color={
                params.row.status === "approved"
                  ? "success"
                  : params.row.status === "pending"
                  ? "warning"
                  : "error"
              }
            />
          </div>
        );
      },
      sortable: false,
    },
  ];
  return (
    <Box>
      <Typography
        fontSize={"20px"}
        sx={{ fontWeight: "medium", marginBottom: "10px" }}
      >
        Ratings & Reviews
      </Typography>

      <Box sx={{ height: "80vh", paddingBottom: "10px" }}>
        <DataGrid
          disableColumnFilter
          disableColumnMenu
          className="datagrid"
          rows={data}
          localeText={{ noRowsLabel: "No review available." }}
          columns={reviewColumn.concat(actionColumn)}
          pagination
          pageSize={PAGE_SIZE}
          rowCount={totalPages * PAGE_SIZE}
          paginationMode="server"
          loading={loading}
          onPageChange={(newPage) => setPage(newPage)}
        />
      </Box>
    </Box>
  );
};

export default Reviews;
